import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-social-link.css.lit';

import '../se-link/se-link';
import '../../base/outline-icon/outline-icon';

export const seSocialLinkVariants = [
  'facebook',
  'youtube',
  'twitter',
  'instagram',
  'linkedin',
  'mail',
  'rss',
  'pinterest',
] as const;

export type SeSocialLinkVariant = typeof seSocialLinkVariants[number];

export const seSocialLinkColors = ['white', 'blue', 'gray'] as const;

export type SeSocialLinkColor = typeof seSocialLinkColors[number];

const colorValues = {
  white: 'neutral-white',
  blue: 'primary-2',
  gray: 'brand-neutral-gray-800',
};

const shareLinks = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  twitter: 'https://twitter.com/intent/tweet?text=&url=',
  pinterest:
    'https://pinterest.com/pin/create/button/?media=&description=&url=',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  mail: '',  
  youtube: '',
  instagram: '',
  rss: '',
};

/**
 * The SeSocialLink component
 * @element se-social-link
 */
@customElement('se-social-link')
export class SeSocialLink extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  variant: SeSocialLinkVariant;

  @property({ type: String })
  url: string;

  @property({ type: String })
  color: SeSocialLinkColor = 'white';

  @property({ type: String })
  label: string;

  @property({ type: String })
  size = '24px';

  @property({ type: Boolean })
  share: boolean;

  @property({ type: String })
  title: string;

  @property({ type: String, attribute: 'content-type' })
  contentType: string;

  render(): TemplateResult {
    // Specifically for mail sharing,
    // create mailto link.
    if (this.variant === 'mail') {
      
      let emailSubject = `${this.title}`;
      let emailBody = 'Here is the latest from Saul Ewing. ';

      if (this.contentType === 'career') {
        emailSubject = `Saul Ewing Careers: ${this.title}`;
        emailBody = `See full ${this.title} position details. `;
      }
      // Encode values to be URL friendly.
      const encodedEmailSubject = encodeURIComponent(emailSubject);
      const encodedEmailBody = encodeURIComponent(emailBody);

      shareLinks[this.variant] = `mailto:?subject=${encodedEmailSubject}&body=${encodedEmailBody}`;
    }


    const url = this.share
      ? `${shareLinks[this.variant]}${window.location.href}`
      : this.url;
    const socialNetwork = this.variant
      ? this.variant[0].toUpperCase() + this.variant.slice(1)
      : '';
    if (!this.label)
      this.label = this.share
        ? `Share this page on ${socialNetwork}`
        : socialNetwork;

    return html`
    <i class="social-link">
      <se-link
        label="${this.variant}"
        link-href="${url}"
        link-target="_blank"
      >
        <outline-icon
          library="system"
          size="${this.size}"
          color="${colorValues[this.color]}"
          name="${this.variant}"
          label="${this.label}"
        />
        </outline-icon>
      </se-link>
    </i>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'se-social-link': SeSocialLink;
  }
}
